import CardShimmer from "./CardShimmer";

const SearchShimmer = () => {
  return (
    <div className="text-6xl pt-[35%] md:pt-[5%] w-full">
      <div className=" px-[1%] bg-[#384e75] w-1/2 py-8 mx-auto rounded-lg animate-pulse"></div>

      <div className="grid grid-cols-2 gap-2 m-5 md:hidden">
        <CardShimmer />
        <CardShimmer />
        <CardShimmer />
        <CardShimmer />
        <CardShimmer />
        <CardShimmer />
        <CardShimmer />
        <CardShimmer />
      </div>

      <div className="hidden md:grid md:grid-cols-5 md:gap-4 md:my-10 md:mx-6  ">
        <CardShimmer />
        <CardShimmer />
        <CardShimmer />
        <CardShimmer />
        <CardShimmer />
        <CardShimmer />
        <CardShimmer />
        <CardShimmer />
        <CardShimmer />
        <CardShimmer />
        <CardShimmer />
        <CardShimmer />
        <CardShimmer />
        <CardShimmer />
        <CardShimmer />
      </div>
    </div>
  );
};

export default SearchShimmer;
